
const getDivisionName = selectedNodes => {
  const division = selectedNodes.find(({ type }) => type === 'division' || type === 'sub-division');
  return division ? division.name : '';
}

export default ({
  brandName,
  abbrNameForTealium,
  selectedNodes,
}) => {

  const divisionName = getDivisionName(selectedNodes);

  return brandName === 'gapfs' ? `${brandName}:${divisionName}` : `${abbrNameForTealium}:${divisionName}`;
}
